import React, { FC } from 'react';

import { Box } from '@mui/system';

import {
  ComparePaymentPlanTypes,
  PharmacyBillingPageStatuses,
} from '@pharmaplan/common';

import ComparePaymentPlan from '../../../../ComparePaymentPlan';
import CustomTableBack from '../../../../common/CustomTableBack';
import strings from '../../../../../localization';

interface IViewPlans {
  setPageStatus: React.Dispatch<
    React.SetStateAction<PharmacyBillingPageStatuses>
  >;
}

const ViewPlans: FC<IViewPlans> = ({ setPageStatus }) => {
  const goBack = () => {
    setPageStatus(PharmacyBillingPageStatuses.existingPaymentPlan);
  };

  return (
    <Box>
      <Box>
        <CustomTableBack onClick={goBack} backLabel={strings.back} />
      </Box>
      <ComparePaymentPlan
        setPageStatus={setPageStatus}
        screenType={ComparePaymentPlanTypes.upgrade}
      />
    </Box>
  );
};

export default ViewPlans;
